var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"progress-context-menu",on:{"click":_vm.toggleProgressWindow}},[_c('div',{staticClass:"progress-context-menu__wrapper",class:{'progress-context-menu__wrapper--floating': _vm.isProgressWindowOpen}},[(_vm.isProgressWindowOpen)?_c('ProgressIndicatorContextMenu'):_c('ProgressIndicatorNew')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }